import evaluateRule from "./rule";

const evaluateCondition = async (condition, userInfo) => {
    let innerCondition;
    let innerResult;

    if (condition.or !== undefined) {
        for (let i = 0; i < condition.or.length; i++) {
            innerCondition = condition.or[i];
            innerResult = await evaluateCondition(innerCondition, userInfo);

            if (innerResult) {
                return true;
            }
        }

        return false;
    } else if (condition.and !== undefined) {
        for (let i = 0; i < condition.and.length; i++) {
            innerCondition = condition.and[i];
            innerResult = await evaluateCondition(innerCondition, userInfo);

            if (!innerResult) {
                return false;
            }
        }

        return true;
    } else {
        return evaluateRule(condition, userInfo);
    }
};

export default evaluateCondition;
